import React from 'react';

// Renders the answer input for a single question during an active attempt.
// `answer` is the raw shape stored in student_answer_json for that type;
// `onChange` receives the new raw answer object to autosave.
function MockExamQuestionRenderer({ question, answer, onChange }) {
  const options = question.options_snapshot || [];

  if (question.question_type === 'single_choice' || question.question_type === 'true_false') {
    const selected = answer?.selected_option_id || '';
    return (
      <div className="d-flex flex-column gap-12">
        {options.map((o) => (
          <label key={o.id} className="d-flex align-items-center gap-12 p-12" style={{
            border: `2px solid ${selected === o.id ? '#0f9d58' : '#e8f5ee'}`, borderRadius: 10, cursor: 'pointer',
          }}>
            <input type="radio" name={`q-${question.id}`} checked={selected === o.id} onChange={() => onChange({ selected_option_id: o.id })} />
            <span>{o.text}</span>
          </label>
        ))}
      </div>
    );
  }

  if (question.question_type === 'multiple_choice') {
    const selectedIds = answer?.selected_option_ids || [];
    const toggle = (id) => {
      const next = selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id];
      onChange({ selected_option_ids: next });
    };
    return (
      <div className="d-flex flex-column gap-12">
        {options.map((o) => (
          <label key={o.id} className="d-flex align-items-center gap-12 p-12" style={{
            border: `2px solid ${selectedIds.includes(o.id) ? '#0f9d58' : '#e8f5ee'}`, borderRadius: 10, cursor: 'pointer',
          }}>
            <input type="checkbox" checked={selectedIds.includes(o.id)} onChange={() => toggle(o.id)} />
            <span>{o.text}</span>
          </label>
        ))}
      </div>
    );
  }

  if (question.question_type === 'short_text' || question.question_type === 'fill_blank') {
    return (
      <input
        type="text" className="form-control py-11" placeholder="Type your answer"
        value={answer?.text || ''} onChange={(e) => onChange({ text: e.target.value })}
      />
    );
  }

  if (question.question_type === 'numerical') {
    return (
      <input
        type="number" step="any" className="form-control py-11" placeholder="Type a number" style={{ maxWidth: 240 }}
        value={answer?.value ?? ''} onChange={(e) => onChange({ value: e.target.value })}
      />
    );
  }

  if (question.question_type === 'long_answer') {
    return (
      <textarea
        className="form-control py-11" rows={6} placeholder="Type your answer"
        value={answer?.text || ''} onChange={(e) => onChange({ text: e.target.value })}
      />
    );
  }

  return null;
}

export default MockExamQuestionRenderer;
